import constants from '../../../../../common/constants';
import { InputValidation } from './ValidationHook';
import { isHttpsUri } from 'valid-url';
import {
  allowedInternalCodeRepoUrlPrefixes,
  allowedExternalCodeRepoUrlPrefixes,
  allowedGithubUrls,
  appSecTicketValidations,
  githubUrlPrefix,
  codeAmazonUrlPrefix,
  gitLabUrlPrefix,
  isValidCodeAmazonPath,
  isValidGithubRepoPath,
  isValidGitlabRepoPath,
  openSourceTicketValidations,
  isValidCodeAWSPath,
} from '@amzn/awscat-pattern-library-service-model';
import { codeAWSUrlPrefix } from '@amzn/awscat-pattern-library-service-model/dist/utils';

export const inputLengthValidation: InputValidation = [
  (input) => input?.length > 2000,
  constants.MUST_BE_LESS_THAN_2000_INPUT_ERROR,
];
export const requiredFieldValidation: InputValidation = [
  (input) => !input,
  constants.MISSING_REQUIRED_FIELD,
];
export const validUrlValidation: InputValidation = [
  (input) => !isHttpsUri(input),
  constants.CODE_REPO_INVALID_URL,
];

// Restrict URL to list of allowed domain names
export const allowedInternalRepoUrlValidation: InputValidation = [
  (input) => !allowedInternalCodeRepoUrlPrefixes.some((u) => input.startsWith(u)),
  constants.CODE_REPO_URL_INVALID_DOMAIN_ERROR,
];
export const allowedExternalRepoUrlValidation: InputValidation = [
  (input) => !allowedExternalCodeRepoUrlPrefixes.some((u) => input.startsWith(u)),
  constants.CODE_REPO_URL_INVALID_DOMAIN_ERROR,
];

// Verify URL contains path portion. E.g. https://code.amazon.com is not allowed. https://code.amazon.com/myrepo is allowed.
export const urlContainsPathValidation: InputValidation = [
  (input) => !/^https:\/\/.*\/.+$/.test(input),
  constants.CODE_REPO_INVALID_URL,
];

// Restrict Github URL to list of allowed accounts/repositories
export const allowedGithubRepoValidation: InputValidation = [
  (input) =>
    input.startsWith(githubUrlPrefix) &&
    !allowedGithubUrls.some((u) => input.startsWith(`${githubUrlPrefix}${u}`)),
  constants.CODE_REPO_URL_INVALID_GITHUB_REPO_ERROR,
];

export const codeAmazonPathValidation: InputValidation = [
  (input) => input.startsWith(codeAmazonUrlPrefix) && !isValidCodeAmazonPath(input),
  constants.CODE_REPO_INVALID_URL,
];

export const codeAWSPathValidation: InputValidation = [
  (input) => input.startsWith(codeAWSUrlPrefix) && !isValidCodeAWSPath(input),
  constants.CODE_REPO_INVALID_URL,
];

export const githubPathValidation: InputValidation = [
  (input) => input.startsWith(githubUrlPrefix) && !isValidGithubRepoPath(input),
  constants.CODE_REPO_INVALID_URL,
];

export const gitlabPathValidation: InputValidation = [
  (input) => input.startsWith(gitLabUrlPrefix) && !isValidGitlabRepoPath(input),
  constants.CODE_REPO_INVALID_URL,
];

export const appsecTicketAllowedPathValidation: InputValidation = [
  (input) => !appSecTicketValidations.some((isValid) => isValid(input)),
  constants.CODE_REPO_INVALID_URL,
];

export const openSourceReviewUrlAllowedPathValidation: InputValidation = [
  (input) => !openSourceTicketValidations.some((isValid) => isValid(input)),
  constants.CODE_REPO_INVALID_URL,
];
